<!-- @format -->

<template>
  <div>
    <div class="container mt-3">
      <b-row>
        <b-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
          <b-form
            class="container mb-3"
            @submit.stop.prevent="form.id ? update() : save()"
          >
            <b-row>
              <b-col sm="12" md="12" lg="12" xl="12">
                <b-form-group label-size="md">
                  <template slot="label"> Name </template>
                  <b-form-input
                    v-model.trim="$v.form.name.$model"
                    size="md"
                    name="name"
                    :value="form.name"
                    :state="validateState('name')"
                    @change="setValue('name', $event)"
                  />
                </b-form-group>
              </b-col>

              <b-col sm="12" md="12" lg="6" xl="6">
                <b-form-group label-size="md">
                  <template slot="label"> Website </template>
                  <b-form-input
                    v-model.trim="$v.form.website.$model"
                    :value="form.website"
                    :state="validateState('website')"
                    @change="setValue('website', $event)"
                    size="sm"
                    name="website"
                    placeholder="www.yourSite.com"
                  />
                </b-form-group>
              </b-col>
              <b-col sm="12" md="12" lg="6" xl="6">
                <b-form-group label-size="md">
                  <template slot="label"> Info </template>
                  <b-form-select
                    v-model="form.info"
                    :options="infoOptions"
                    size="sm"
                    name="info"
                    :state="validateState('info')"
                    @change="setValue('info', $event)"
                  />
                </b-form-group>
              </b-col>
              <b-col sm="12" md="12" lg="6" xl="6">
                <b-form-group label-size="md">
                  <template slot="label"> Type </template>
                  <b-form-select
                    v-model="form.type"
                    :options="typeOptions"
                    size="sm"
                    name="type"
                    :state="validateState('type')"
                    @change="setValue('type', $event)"
                  />
                </b-form-group>
              </b-col>
              <b-col sm="12" md="6" lg="6" xl="6" class="mb-4" />
              <b-col sm="12" md="3" lg="3" xl="3" class="mb-4">
                <b-button
                  class="float-right"
                  variant="success"
                  type="submit"
                  block
                  :disabled="$v.form.$invalid || isLoading"
                >
                  <b-spinner v-if="isLoading" small variant="white" />
                  <span v-else>{{ $t("save") }}</span>
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { POST_PROVIDER } from "./actions";

import { mapState } from "vuex";

export default {
  name: "ProviderForm",
  props: ["refreshData", "hideModal", "providerItem"],
  data() {
    return {
      isAddressSelected: false,
      address: null,
      form: {
        id: null,
        name: "",

        website: "",
        info: null,
        type: null,
      },

      infoOptions: [
        { value: 1, text: "Manual" },
        { value: 0, text: "API" },
      ],
      typeOptions: [
        { value: 1, text: "Wholesale" },
        { value: 0, text: "Retail" },
      ],
    };
  },
  validations: {
    form: {
      name: {
        required,
      },
      website: {
        required,
      },
      info: {},
      type: {},
    },
  },
  computed: {
    ...mapState({
      user: (state) => state.adminStore.companies.dealer,
      emailValidation: (state) =>
        state.adminStore.companies.emailValidation.data,
    }),
    isLoading() {
      return this.user.status == "fetching" ? true : false;
    },
  },
  mounted() {
    if (this.providerItem) {
      this.formatForm();
    }
  },
  methods: {
    setValue(key, value) {
      this.form[key] = value;
      this.$v.form[key].$touch();
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    async save() {
      const payload = this.formatPayload();
      this.$store
        .dispatch(POST_PROVIDER, payload)
        .then(() => {
          this.$root.$bvToast.toast("Provider successfully registered", {
            title: "Success",
            variant: "success",
          });
          this.refreshData();
          this.hideModal();
        })
        .catch((error) => {
          this.$root.$bvToast.toast(
            error.data.message.charAt(0).toUpperCase() +
              error.data.message.slice(1),
            {
              title: "Error",
              variant: "warning",
            }
          );
        });
    },

    formatPayload() {
      const payload = {
        id: this.form.id ? this.form.id : null,
        name: this.form.name,
        website: this.form.website,
        info: this.form.info,
        type: this.form.type,
        manual: this.form.info == 1 ? 1 : 0,
        api: this.form.info == 0 ? 1 : 0,
        wholesale: this.form.type == 1 ? 1 : 0,
        retail: this.form.type == 0 ? 1 : 0,
      };

      return payload;
    },
    selectAddress() {
      this.isAddressSelected = true;
    },
    formatForm() {
      this.form.id = this.providerItem.id;
      this.form.name = this.providerItem.name;
      this.form.website = this.providerItem.website;
      this.form.info = this.providerItem.manual
        ? 1
        : this.providerItem.api
        ? 0
        : null;
      this.form.type = this.providerItem.wholesale
        ? 1
        : this.providerItem.retail
        ? 0
        : null;
    },
    async update() {
      const payload = this.formatPayload();
      this.$store
        .dispatch(POST_PROVIDER, payload)
        .then(() => {
          this.$root.$bvToast.toast("Provider successfully updated", {
            title: "Success",
            variant: "success",
          });
          this.refreshData();
          this.hideModal();
        })
        .catch((error) => {
          this.$root.$bvToast.toast(
            error.data.messages.charAt(0).toUpperCase() +
              error.data.messages.slice(1),
            {
              title: "Error",
              variant: "warning",
            }
          );
        });
    },
  },
};
</script>

<style></style>
